import { useCallback, useLayoutEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useSwipeToDismiss } from "./useSwipeToDismiss";

// Swipe right to go back — the app-wide back gesture, spread on Layout's
// <main> so every page gets it. Off on the first in-app entry (a deep link
// or fresh launch; the router keys it "default"), where going back would
// leave the app. WorkModal has its own swipe-to-close and sits outside
// Layout, so the two never compete.
export function useSwipeBack() {
  const navigate = useNavigate();
  const location = useLocation();
  const back = useCallback(() => navigate(-1), [navigate]);
  const { ref, reset, ...handlers } = useSwipeToDismiss<HTMLElement>(back);

  // <main> stays mounted across routes, so clear the swipe offset on arrival
  // — including back on the first entry, hence the ref is always attached.
  useLayoutEffect(reset, [location.key, reset]);

  return location.key !== "default" ? { ref, ...handlers } : { ref };
}
